import BaseComponent from '../../../../base/base_component';
import DateFormatter from '../../../../utils/date_formatter';
import DOM from '../../../../utils/dom';
import _ from '../../../../utils/underscore';
import { BaseComponentParams } from '../../../../base/base_component_interface';
import {LAST_LOGIN_SELECTORS, LAST_LOGIN_TITLE_TRANSLATION_KEY} from './last_login_consts';

const lastLoginView = require('./view/last_login.html');

interface LastLoginInitParams extends BaseComponentParams {
  textClass: string;
  resultClass: string;
  containerClass: string;
  datetime?: string;
}

class LastLoginComponentController extends BaseComponent {

  static CLASS: string = 'LastLoginComponentController';
  private _datetime: string;
  private _textClass: string;
  private _resultClass: string;
  private _containerClass: string;

  init(params: LastLoginInitParams) {
    if(_.isNullOrUndefined(params)){
      (params as any) = {};
    }
    params.innerHtml = lastLoginView;

    super.init(params);
    this._setInitParams(params);
  }

  private _setInitParams(params: LastLoginInitParams) {
    this._datetime = _.isString(params.datetime) ? params.datetime : '';
    this._textClass = params.textClass;
    this._resultClass = params.resultClass;
    this._containerClass = params.containerClass;
  }

  start() {
    this.renderComponent();
    this._addInputClasses();
    return this;
  }

  public renderComponent(): void {
    const lastLoginWithRegTimeZone = this._getLastLoginWithRegTimeZone();
    if (!_.isNullOrUndefined(lastLoginWithRegTimeZone) && (!_.isNullOrUndefined(lastLoginWithRegTimeZone.LastLogin) || !_.isNullOrUndefined(lastLoginWithRegTimeZone.LastLoginDateInTimeZone))) {
      const lastLogin = this.serviceFactory.clockService().formatToRegulationOffset(lastLoginWithRegTimeZone.LastLogin, lastLoginWithRegTimeZone.LastLoginDateInTimeZone);

      // if it's not local time, in order to prevent DateFormatter from create Date object in local time and
      // change it for the local date string, we have to pass isUTC flag to be true. This avoids changing the date
      // We got the date as UTC without 'Z' - convert to UTC correct format

      const formattedText = this._getFormattedText(lastLogin.date + 'Z', lastLogin.isUTC);
      const lastLoginText = _.isString(formattedText) ? formattedText : '';

      DOM.text(this.querySelector(LAST_LOGIN_SELECTORS.TITLE), this.serviceFactory.languageService().translation(LAST_LOGIN_TITLE_TRANSLATION_KEY));
      DOM.text(this.querySelector(LAST_LOGIN_SELECTORS.VALUE), lastLoginText);
    } else {
      // Remove last login text
      const lastLoginTextElem = this.getEl().querySelector(LAST_LOGIN_SELECTORS.CONTAINER);
      if(lastLoginTextElem && _.isFunction(lastLoginTextElem.remove)){
        lastLoginTextElem.remove();
      }
      DOM.html('', this.getEl());
    }
  }

  private _getFormattedText(lastLogin: any, isUTC: boolean): any {
    return DateFormatter.format(lastLogin, this._getDateTimeFormat(), isUTC);
  }

  private _addInputClasses(): void {
    const titleTextClass = this._textClass;
    const resultTextClass = this._resultClass;
    const containerClass = this._containerClass;

    if (typeof titleTextClass === 'string') {
      const lastLoginTitle = this.getEl().querySelector(LAST_LOGIN_SELECTORS.TITLE);
      if(lastLoginTitle){
        lastLoginTitle.classList.add(titleTextClass);
      }
    }

    if (typeof resultTextClass === 'string') {
      const lastLoginElement = this.getEl().querySelector(LAST_LOGIN_SELECTORS.VALUE);
      if(lastLoginElement){
        lastLoginElement.classList.add(resultTextClass);
      }
    }

    if (typeof containerClass === 'string') {
      const lastLoginContainer = this.getEl().querySelector(LAST_LOGIN_SELECTORS.CONTAINER);
      if(lastLoginContainer){
        lastLoginContainer.classList.add(containerClass);
      }
    }
  }

  //retrieve last login from UserService
  private _getLastLoginWithRegTimeZone(): any {
    return this.serviceFactory.oAuth2Service().isAuthorized()
      ? this.serviceFactory.userService().getHistoryToken()
      : null;
  }

  //Get the dateTime format for last login
  private _getDateTimeFormat(): string {
    return this._datetime || this.serviceFactory.skinService().getDateTimeHistoryFormat();
  }
}

export default LastLoginComponentController;
